import React from 'react';
import { t } from 'ttag';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import { Button } from '@coolremote/shared';

const UserSwitchDialog = ({
  open,
  currentUserEmail,
  inviteEmail,
  onIgnore,
  onLogout
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      aria-labelledby="user-switch-dialog-title"
      aria-describedby="user-switch-dialog-description"
    >
      <DialogTitle id="user-switch-dialog-title">
        {t`User Account Conflict`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="user-switch-dialog-description">
          {t`You are currently logged in as ` + currentUserEmail +
            t`.\nYou can Log out and continue registration as ` +
            ` ${inviteEmail}` + ` or stay logged in and complete registration later`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onIgnore}
          style={{ backgroundColor: '#666666', color: '#ffffff' }}
        >
          {t`Ignore`}
        </Button>
        <Button
          onClick={onLogout}
          style={{ backgroundColor: '#1976d2', color: '#ffffff' }}
        >
          {t`Logout`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { UserSwitchDialog };
